'use strict';

module.exports = require('./LM');
module.exports.Matrix = require('ml-matrix');
module.exports.Matrix.algebra = require('./algebra');



/*****************
 ** WEBPACK FOOTER
 ** ./~/curve-fitting/src/index.js
 ** module id = 7
 ** module chunks = 0
 **/